import React from 'react';
import { getEnviroment } from '../../../lib/utils.es6';
import { getPartnerGuid, getAuthorizationToken } from '../../../lib/access.es6';
import { buildAgentParams } from '../shared/agentParams';

const STAGING_BASE_URL = 'https://group-portal.staging.aspin-inclusivity.com';
const PRODUCTION_BASE_URL = 'https://group-portal.inclusivity-aspin.com';

class PolicyAmend extends React.Component {
  render() {
    const partnerGuid = getPartnerGuid();
    const environment = getEnviroment();
    const baseUrl = environment === 'prod' ? PRODUCTION_BASE_URL : STAGING_BASE_URL;
    const bearerToken = getAuthorizationToken();
    const host_base_url = window.location.origin;

    // Support both route param (/amend-policy/:policy_number) and query param
    // (?policy_number=...) for policy numbers containing special characters.
    const policyNumber =
      (this.props.params && this.props.params.policy_number) ||
      (this.props.location && this.props.location.query && this.props.location.query.policy_number);

    const iframeSrc =
      baseUrl +
      '/?partner=' + encodeURIComponent(partnerGuid) +
      '&source=' + encodeURIComponent('aspin') +
      '&journey=' + encodeURIComponent('policy-management') +
      '&bearer_token=' + encodeURIComponent(bearerToken) +
      '&host_base_url=' + encodeURIComponent(host_base_url) +
      '&environment=' + encodeURIComponent(environment) +
      (policyNumber ? '&policy_number=' + encodeURIComponent(policyNumber) : '') +
      buildAgentParams();

    return (
      <section
        style={{
          background: '#FFFFFF',
          borderRadius: '8px',
          marginTop: '30px',
          marginBottom: '30px',
          width: '100%',
        }}
      >
        <iframe
          src={iframeSrc}
          title="Amend Policy"
          style={{
            width: '100%',
            height: 'calc(100vh - 160px)',
            border: 'none',
          }}
        ></iframe>
      </section>
    );
  }
}

export default PolicyAmend;
